import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AttendanceListEditor.html?raw';
import "./AttendanceListEditorTypes";
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/CheckBox/CheckBox";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import "../../../moreCore/UI/StaticTable/StaticTable";
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import "../../../moreCore/UI/SelectBox/SelectBox";
import _StatefulBase from '../../../moreCore/UI/_StatefulBase/_StatefulBase';


interface RowWidget {
    entity: any;
    widgets: Array<any>;
    tableRow: StaticTable.StaticTableRow<any>;
}
class AttendanceListEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;

    staticTable: MdsLax<InstanceType<typeof StaticTable>>;
    tableContainer: HTMLElement; 
    batchEitingControls_container: HTMLElement; 

    // BE heißt batch edit
    BE_dutyTypeActual: MdsLax<InstanceType<typeof SelectBox>>;
    BE_functionalSubGroupActual: MdsLax<InstanceType<typeof SelectBox>>;
    BE_noteStageManager: HTMLTextAreaElement;
    BE_saveButton: HTMLButtonElement;

    batchEditButton: HTMLElement; // wird im GenereicDialog aus dem Parentwidget gebaut und hier für referenz gespeichert

    widgetRegistry: Array<RowWidget>;
    unsavedRowIndexes: Array<number> = [];
    rows_savingInProcess: Array<{ entity: { ID: string }, rowIndex: number }> = [];
    bookingId: string = null;

    _request: any = null;
    saveDataControllerurl = "AttendanceList/SaveRowData";
    loadDataControllerurl = "AttendanceList/GetEmploymentListForBooking";
    _textAreaTimeout: number;
    data: object[] = null;

    duty_types: Array<{ ID: string, code: string, description: string }> = [];
    functional_sub_groups: Array<{ ID: string, description: string, ref_functional_group: string }> = [];

    not_inspected_entities: Array<{ ID: string }> = [];
    all_table_entites: Array<{ID:string}> = [];

    notInspectedOnly: boolean = true;

    isBatchEditingActive: boolean = true;
    rowsMarkedForEditing: Array<{ entity: {}, rowIndex: number }> = [];
    markedFunctionalGroups: Array<{ ID: string, counter: number }> = [];

    constructor(data?: object[]) {
        super(...(arguments as unknown as []));
        if (data) {
            this.data = data;
        }
    }

    tableLayout: StaticTable.Layout = {
        "name": "default",
        label: "?",
        rows: [{
            "attributes": 
                [
                    "ref_associate.gDisp_Name_Firstname",
                    "ref_functional_group.description",
                    "ref_functional_sub_group.description",
                    "ref_vt_duty_type.description",
                ],
                
            "colspans": 
                [
                    1,
                    1,
                    1,
                    1
                ],
            "headings": 
                [
                    (this as any).translations["AttendanceList__LayoutHeader_musician"],
                    (this as any).translations["AttendanceList__LayoutHeader_functionalGroup"],
                    (this as any).translations["AttendanceList__LayoutHeader_function"],
                    (this as any).translations["AttendanceList__LayoutHeader_dutyType"],
                ],
            colNamesInternal: [
            ]
    },
            {
                attributes: ["ref_associate.gDisp_Name_Firstname"],
                colspans: [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                headings: [
                    (this as any).translations["AttendanceList__LayoutHeader_musician"],
                    (this as any).translations["AttendanceList__LayoutHeader_actualDutyType"],
                    (this as any).translations["AttendanceList__LayoutHeader_actualFunction"],
                    (this as any).translations["AttendanceList__LayoutHeader_noteStageManageer"],
                    (this as any).translations["AttendanceList__LayoutHeader_save"]
                ],
                colNamesInternal: [
                    (this as any).translations["AttendanceList__LayoutHeader_musician"],
                    (this as any).translations["AttendanceList__LayoutHeader_actualDutyType"],
                    (this as any).translations["AttendanceList__LayoutHeader_actualFunction"],
                    (this as any).translations["AttendanceList__LayoutHeader_noteStageManageer"],
                    (this as any).translations["AttendanceList__LayoutHeader_save"]]
            }]
    };

    batchEditTableLayout: StaticTable.Layout = {
        "name": "default",
        label: "?",
        rows: [{
            "attributes": [
                "ref_associate.gDisp_Name_Firstname",
                "ref_functional_group.description",
                "ref_functional_sub_group.description",
                "ref_vt_duty_type.description",
            ],
            "colspans": [
                1,
                1,
                1,
                1,
                1
            ],
            colNamesInternal: [
                (this as any).translations["AttendanceList__LayoutHeader_musician"],
                (this as any).translations["AttendanceList__LayoutHeader_functionalGroup"],
                (this as any).translations["AttendanceList__LayoutHeader_function"],
                (this as any).translations["AttendanceList__LayoutHeader_dutyType"],
                (this as any).translations["AttendanceList__LayoutHeader_multiplePaxCheckbox"],],

            "headings": [

                (this as any).translations["AttendanceList__LayoutHeader_musician"],
                (this as any).translations["AttendanceList__LayoutHeader_functionalGroup"],
                (this as any).translations["AttendanceList__LayoutHeader_function"],
                (this as any).translations["AttendanceList__LayoutHeader_dutyType"],
                (this as any).translations["AttendanceList__LayoutHeader_multiplePaxCheckbox"],
            ]
        }]
    };

    table_formatterFunction(cell: StaticTable.StaticTableCell<any>) {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let index = cell.tableRow.lineIndex;
        let value = cell.value;
        console.log("formatter", index, value)
        switch (colName) {
            case this.translations["AttendanceList__LayoutHeader_actualDutyType"]:
                let selectBox_dutyType = new SelectBox();

                selectBox_dutyType["name"] = "ref_vt_duty_type_actual";

                selectBox_dutyType.setLabel(this.translations["AttendanceList__LayoutHeader_dutyType"]);

                this.UiModder.domStyle.set(selectBox_dutyType.domNode, "max-width", "300px");
                if (this.staticTable.domNode.getBoundingClientRect().width < 900) {
                    //this.UiModder.domClass.add(node, "w3-right"); // macht die Zelle/Layout kaputt!!
                } else {
                    this.UiModder.domClass.remove(node, "w3-right");
                }

                this.addWidgetToRegistry(selectBox_dutyType, cell);
                if (this.duty_types) {
                    for (let duty_type of this.duty_types) {
                        selectBox_dutyType.addOption(duty_type.ID, duty_type.description, true);
                    }

                    selectBox_dutyType.constructOptions();

                    if (!entity["ref_vt_duty_type_actual"] || !entity["ref_vt_duty_type_actual"].ID) {

                        if (entity["ref_vt_duty_type"]) selectBox_dutyType.setValue(entity["ref_vt_duty_type"].ID);
                    } else {
                        selectBox_dutyType.setValue(entity["ref_vt_duty_type_actual"].ID);
                    }

                } else {
                    selectBox_dutyType.setPlaceholder(this.translations["AttendanceListEditor__selectBox_placeholder_nothingToChooseFrom"]);
                }

                selectBox_dutyType.placeAt(node);
                selectBox_dutyType.on("change", lang.hitch(this, "_onChange_dutyType", { entity: entity, rowIndex: index }));
                return true;
                break;

            case this.translations["AttendanceList__LayoutHeader_actualFunction"]:

                let selectBox_actualFunction = new SelectBox();

                selectBox_actualFunction["name"] = "ref_functional_sub_group_actual";

                selectBox_actualFunction.setLabel(this.translations["AttendanceList__LayoutHeader_actualFunction"]);

                this.UiModder.domStyle.set(node, "width", "100%");
                this.UiModder.domStyle.set(selectBox_actualFunction.domNode, "max-width", "300px");
                if (this.staticTable.domNode.getBoundingClientRect().width < 910) {
                    //this.UiModder.domClass.add(node, "w3-right"); // macht die Zelle/Layout kaputt!!
                } else {
                    this.UiModder.domClass.remove(node, "w3-right");
                }

                this.addWidgetToRegistry(selectBox_actualFunction, cell);


                if (this.functional_sub_groups) {
                    let funGroupId: string = null;
                    if (entity["ref_functional_group"] && entity["ref_functional_group"].ID) funGroupId = entity["ref_functional_group"].ID;

                    for (let functional_sub_group of this.functional_sub_groups) {

                        if (functional_sub_group.ref_functional_group == funGroupId) selectBox_actualFunction.addOption(functional_sub_group.ID, functional_sub_group.description, true);
                    }

                    selectBox_actualFunction.constructOptions();

                    if (!entity["ref_functional_sub_group_actual"] || !entity["ref_functional_sub_group_actual"].ID) {
                        if (entity["ref_functional_sub_group"]) selectBox_actualFunction.setValue(entity["ref_functional_sub_group"].ID);
                    } else {
                        selectBox_actualFunction.setValue(entity["ref_functional_sub_group_actual"].ID);
                    }

                } else {
                    selectBox_actualFunction.setPlaceholder(this.translations["AttendanceListEditor__selectBox_placeholder_nothingToChooseFrom"]);
                }

                selectBox_actualFunction.placeAt(node);
                selectBox_actualFunction.on("change", lang.hitch(this, "_onChange_actualFuntion", { entity: entity, rowIndex: index }));
                return true;
                break;
            case this.translations["AttendanceList__LayoutHeader_noteStageManageer"]:
                // textarea
                let note: string = this.PitHelper.getEntityAttributeValue(entity, "note_inspecient", more.PitHelperStructureFormatType.json);
                let textArea = this.UiModder.domConstruct.create("textarea", {
                    "placeholder": this.translations["AttendanceListEditor__textAtrea_placeholder"],
                    "name": "note",
                    "rows": 3,
                    "onkeyup": lang.hitch(this, "_onKeyUpTextarea", { entity: entity, rowIndex: index }),
                    "style": "resize: none",
                    "innerHTML": note,
                    "class": "w3-input w3-hover-gray",
                }, node);
                this.addWidgetToRegistry(textArea, cell);
                return true;
                break;
            case this.translations["AttendanceList__LayoutHeader_save"]:

                let disabled: boolean = false;

                if (entity["ref_vt_duty_type_actual"] && entity["ref_functional_sub_group_actual"]) disabled = true;

                var btn = this.UiModder.domConstruct.create("BUTTON", {
                    //"innerHTML": "<i class='fas fa-save'></i>",
                    "innerHTML": this.translations["AttendanceList__LayoutHeader_save"],
                    "class": "mds-button-base round w3-padding w3-block w3-large w3-right secondaryBG mds-hover-dark",
                    "style": "margin-top: 20px",
                    "disabled": disabled,
                    "value": index,
                    "onclick": lang.hitch(this, "tableRowButton_click_saveData", { entity: entity, rowIndex: index })
                }, node);
                this.addWidgetToRegistry(btn, cell);
                return true;
                break;


            case this.translations["AttendanceList__LayoutHeader_multiplePaxCheckbox"]: // batch Edit
                let checkbox = new CheckBox();
                checkbox.setLabel(this.translations["AttendanceList__LayoutHeader_multiplePaxCheckbox_label"]);

                this.addWidgetToRegistry(checkbox, cell);

                this.UiModder.domStyle.set(checkbox.domNode, "justify-content", "flex-end");

                checkbox.placeAt(node);

                checkbox.on("change", lang.hitch(this, "_onChangeMultiplePaxCheckBox", { entity: entity, rowIndex: index }));
                return true;
                break;

            default:
                return false;
        }
    }

    addWidgetToRegistry(widget: any, cell: StaticTable.StaticTableCell<any>): void {
        let regEntry = this.getRegistryEntryByRowIndex(cell.tableRow.lineIndex);

        if (regEntry == null) {
            regEntry = {
                tableRow: cell.tableRow,
                widgets: [],
                entity: cell.entity
            };

            this.widgetRegistry.push(regEntry);
        }

        regEntry.widgets.push(widget);

    }

    getRegistryEntryByRowIndex(index: number): RowWidget {
        for (let widget of this.widgetRegistry) {
            if (widget.tableRow.lineIndex == index) {
                return widget;
            }
        }

        return null;
    }


    _addEntityToRegistry(entity: { ID: string }, registry: Array<{ ID: string}>): void {

        let index: number = -1;

        for (let i = 0; i < registry.length; i++) {
            if (registry[i].ID == entity.ID) {
                index = i;
            }
        }

        if (index == -1) {
            registry.push(entity);
        } else {
            registry[index] = entity;
        }
    }

    _removeEntityFromRegistry(entity: { ID: string }, registry: Array<{ ID: string }>): void {
        let index: number = -1;

        for (let i = 0; i < registry.length; i++) {
            if (registry[i].ID == entity.ID) {
                index = i;
            }
        }

        if (index != -1) {
            registry.splice(index,1);
        } else {
            console.log("no entry ", entity, " in registry: ",  registry);
        }
    }

    //// BATCH EDIT ---------------------------------------------START

    _onclickBatchEditButton(): void {

        this.isBatchEditingActive = !this.isBatchEditingActive;

        this.rowsMarkedForEditing = [];
        this.markedFunctionalGroups = [];

        if (this.isBatchEditingActive) {
            this.UiModder.domAttr.set(this.batchEditButton, "innerHTML", this.translations["AttendanceList__batchEditButtonLabel_single"]);
            this._onLoadData_Response(this.data);
        } else {
            this.UiModder.domAttr.set(this.batchEditButton, "innerHTML", this.translations["AttendanceList__batchEditButtonLabel_multiple"]);
            this._onLoadData_Response(this.data);
        }
    }

    _onChange_BE_dutyTypeActual(): void {

        if (this._isBEValuelDirty() === true && this.rowsMarkedForEditing.length > 0) {
            this.UiModder.domAttr.remove(this.BE_saveButton, "disabled");
        } else {
            this.UiModder.domAttr.set(this.BE_saveButton, "disabled", true);
        }
    }
    _onChange_BE_functionalSubGroupActual(): void {
        if (this._isBEValuelDirty() === true && this.rowsMarkedForEditing.length > 0) {
            this.UiModder.domAttr.remove(this.BE_saveButton, "disabled");
        } else {
            this.UiModder.domAttr.set(this.BE_saveButton, "disabled", true);
        }
    }
    _onhkeyUp_BE_noteStageManager(): void {
        if (this._isBEValuelDirty() === true && this.rowsMarkedForEditing.length > 0) {
            this.UiModder.domAttr.remove(this.BE_saveButton, "disabled");
        } else {
            this.UiModder.domAttr.set(this.BE_saveButton, "disabled", true);
        }
    }

    _isBEValuelDirty(): boolean {
        let result: boolean = false;

        let dutyTypeID: string = this.BE_dutyTypeActual.getValue();
        let subGroupID: string = this.BE_functionalSubGroupActual.getValue();
        let noteStageManager: string = this.BE_noteStageManager.value.trim();

        if (dutyTypeID && dutyTypeID != "x") result = true;
        if (subGroupID && subGroupID != "x") result = true;
        if (noteStageManager) result = true;

        return result;
    }

    _onclick_BE_saveButton(): void {

        let dutyTypeID: string = this.BE_dutyTypeActual.getValue();
        let subGroupID: string = this.BE_functionalSubGroupActual.getValue();
        let noteStageManager: string = this.BE_noteStageManager.value.trim();

        let data: {
            EntityIDs: string[], dutyTypeActual: string, functionalSubGroupActual: string, noteStageManager: string
        } = { EntityIDs: [], dutyTypeActual: null, functionalSubGroupActual: null, noteStageManager: null }

        if (dutyTypeID && dutyTypeID != "x") data.dutyTypeActual = dutyTypeID;
        if (subGroupID && subGroupID != "x") data.functionalSubGroupActual = subGroupID;
        if (noteStageManager) data.noteStageManager = noteStageManager;

        for (let rowData of this.rowsMarkedForEditing) {
            data.EntityIDs.push(rowData.entity["ID"]);
        }

        this.StandbyStart();

        this.RequestManager.post(
            window.appRoot + "AttendanceList/SaveBatchEditData",
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, "_onSaveBatchEditData_Response"),
            lang.hitch(this, function (err) { // errorCallback
                this.StandbyStop();
                if (err && err["Message"]) {
                    alert("ERROR beim Laden von Daten: " + err["Message"]);
                    console.log(err);
                }
            })
        );
    }

    _onSaveBatchEditData_Response(response): void {
        this.StandbyStop();
        if (response && response.savedEntities && response.savedEntities.length) {
            if (this.isBatchEditingActive == true) {
                this.rowsMarkedForEditing = [];
                this.markedFunctionalGroups = [];
            }

            this.loadData(this.bookingId);
        }
    }

    _onChangeMultiplePaxCheckBox(rowData: { entity: {}, rowIndex: number }): void {

        let isChecked: boolean;
        let rowsMarkedIndex: number = -1;
        let markedFunctionalGroupIndex: number = -1;
        let regEntry = this.getRegistryEntryByRowIndex(rowData.rowIndex);
        let rowWidgets: Array<MdsLax<InstanceType<typeof _StatefulBase>>> = [];
        if (regEntry) {
            rowWidgets = regEntry.widgets;
        }

        for (let rowWidget of rowWidgets) {
            if (rowWidget["getChecked"]) { // wenn es eine Checkbox ist
                isChecked = (<MdsLax<InstanceType<typeof CheckBox>>>rowWidget).getChecked();
            }
        }

        for (let i = 0; i < this.rowsMarkedForEditing.length; i++) {
            if (this.rowsMarkedForEditing[i].rowIndex == rowData.rowIndex) {
                rowsMarkedIndex = i
            }
        }

        for (let j = 0; j < this.markedFunctionalGroups.length; j++) {
            if (this.markedFunctionalGroups[j] && rowData.entity["ref_functional_group"] && this.markedFunctionalGroups[j].ID == rowData.entity["ref_functional_group"].ID) {
                markedFunctionalGroupIndex = j
            }
        }

        if (isChecked == true) {


            if (rowsMarkedIndex == -1) {
                this.rowsMarkedForEditing.push(rowData);
            }
            if (markedFunctionalGroupIndex > -1) {
                this.markedFunctionalGroups[markedFunctionalGroupIndex].counter++
            } else if (rowData.entity["ref_functional_group"]) {
                this.markedFunctionalGroups.push({ ID: rowData.entity["ref_functional_group"].ID, counter: 1 });
            }

        } else {
            if (rowsMarkedIndex > -1) this.rowsMarkedForEditing.splice(rowsMarkedIndex, 1);

            if (markedFunctionalGroupIndex > -1) {
                this.markedFunctionalGroups[markedFunctionalGroupIndex].counter--
                if (this.markedFunctionalGroups[markedFunctionalGroupIndex].counter < 1) this.markedFunctionalGroups.splice(markedFunctionalGroupIndex, 1);
            }
        }

        this.setMarkedRowsStyle();

        this._create_BE_functionalSubGroupActual_options();

        if (this.rowsMarkedForEditing.length > 0) {
            this.UiModder.domAttr.remove(this.BE_saveButton, "disabled");
        } else if (this.rowsMarkedForEditing.length == 0) {
            this.UiModder.domAttr.set(this.BE_saveButton, "disabled", true);
        } else {
            throw "Errror";
        }

    }

    setMarkedRowsStyle(bOnViewChange?: boolean): void {

        let tableRows: HTMLCollectionOf<Element> = this.staticTable.domNode.getElementsByTagName("tr");
        let rowCount = this.staticTable.getRowCount(); // achtung, rowGroupcount.
        let markedRowIndexes: Array<number> = [];

        for (let k = 0; k < this.rowsMarkedForEditing.length; k++) {
            markedRowIndexes.push(this.rowsMarkedForEditing[k].rowIndex);
        }

        console.log("rows marked for editing: ", this.rowsMarkedForEditing)

        for (let i = 0; i < tableRows.length; i++) {

            let row = tableRows[i];

            let tr_index: number = Number(this.UiModder.domAttr.get(row, "data-tr_index"));
            let regEntry = this.getRegistryEntryByRowIndex(tr_index);
            let rowWidgets: Array<MdsLax<InstanceType<typeof _StatefulBase>>> = [];
            if (regEntry) {
                rowWidgets = regEntry.widgets;
            }

            let isMarked: boolean = markedRowIndexes.indexOf(tr_index) != -1;

            if (isMarked) {
                this.UiModder.domClass.add(row, "rowMarkedForEditing");
            } else {
                this.UiModder.domClass.remove(row, "rowMarkedForEditing");
            }

            if (bOnViewChange === true) {
                for (let rWidget of rowWidgets) {
                    try {
                        if (!rWidget._destroyed) {
                            if (/CheckBox/.test(rWidget.id)) {
                                rWidget.setValue(isMarked, true);
                            }
                        }
                    } catch (ex) {

                    }
                }
            }
            
        }
    }

    _create_BE_functionalSubGroupActual_options(): void {

        this.BE_functionalSubGroupActual.clear();

        this.BE_functionalSubGroupActual.setBlankOption("x", "---", true);

        for (let funcGroup of this.markedFunctionalGroups) {
            for (let functional_sub_group of this.functional_sub_groups) {

                if (functional_sub_group.ref_functional_group == funcGroup.ID) this.BE_functionalSubGroupActual.addOption(functional_sub_group.ID, functional_sub_group.description, true);
            }
        }

        this.BE_functionalSubGroupActual.constructOptions();
    }

    _onclick_BE_selectAllButton(evt): void {

        for (let regEntry of this.widgetRegistry) {
            let rowWidgets = regEntry.widgets;
            for (let widget of rowWidgets) {
                if (/CheckBox/.test(widget.id)) {
                    widget.setValue(true);
                }
            }
        }
    }

    _onclick_BE_unselectAllButton(evt): void {

        for (let regEntry of this.widgetRegistry) {
            let rowWidgets = regEntry.widgets;
            for (let widget of rowWidgets) {
                if (/CheckBox/.test(widget.id)) {
                    widget.setValue(false);
                }
            }
        }
    }


    //// BATCH EDIT --------------------------------------------- END

    _onChange_dutyType(rowData: { entity: object, rowIndex: number }): void {
        this._setIsRowDirtyStyle(rowData);
    }
    _onChange_actualFuntion(rowData: { entity: object, rowIndex: number }): void {
        this._setIsRowDirtyStyle(rowData);
    }
    _onKeyUpTextarea(rowData: { entity: object, rowIndex: number }): void {
        this._setIsRowDirtyStyle(rowData);
    }
    isRowDirty(rowData: { entity: object, rowIndex: number }): boolean {
        // bestimmt ob rowwidgets umd rowdata enitiy dispkrepanz aufweisen
        //
        // zu beachten: wenn blancoption ausgewählt ist, gehört die geplante value in die tatsächliche übertragen, 
        // das Speiichern soll dabei weiterhin möglih sein ( wird in _setIsRowDirtyStyle (en)/(dis)abled )

        let isDirty: boolean = false;

        let rowIndex = rowData["rowIndex"];
        let regEntry = this.getRegistryEntryByRowIndex(rowData.rowIndex);
        let rowWidgets: Array<MdsLax<InstanceType<typeof _StatefulBase>>> = [];
        if (regEntry) {
            rowWidgets = regEntry.widgets;
        }
        let rowWidetValues: object = {};

        // get value from rowwidgets

        for (let i = 0; i < rowWidgets.length; i++) {

            if (rowWidgets[i]["name"] && rowWidgets[i]["name"] == "note") {
                rowWidetValues["note_stage_manager"] = rowWidgets[i]["value"];
            } else if (rowWidgets[i]["name"] && rowWidgets[i]["name"] == "ref_vt_duty_type_actual") {
                rowWidetValues["ref_vt_duty_type_actual"] = rowWidgets[i].getValue();
            } else if (rowWidgets[i]["name"] && rowWidgets[i]["name"] == "ref_functional_sub_group_actual") {
                rowWidetValues["ref_functional_sub_group_actual"] = rowWidgets[i].getValue();
            }
        }

        // rowWidetValues hat jetzt alle values

        // wenn Dienst ist bereits inspiziert aber die input value abweicht von der gespeicherten - button enablen
        if (
            // wenn es ref_vt_duty_type_actual schon gibt und die input value ist keine blancoption und entspricht nicht der gespeicherten value
            (rowData.entity["ref_vt_duty_type_actual"] && (rowWidetValues["ref_vt_duty_type_actual"] != "x" && rowWidetValues["ref_vt_duty_type_actual"] != rowData.entity["ref_vt_duty_type_actual"].ID)) ||
            // wenn es ref_functional_sub_group_actual schon gibt und die input value ist keine blancoption und entspricht nicht der gespeicherten value
            (rowData.entity["ref_functional_sub_group_actual"] && (rowWidetValues["ref_functional_sub_group_actual"] != "x" && rowWidetValues["ref_functional_sub_group_actual"] != rowData.entity["ref_functional_sub_group_actual"].ID)) ||
            // input value entspricht nicht der gespeicherten value
            (rowWidetValues["note_stage_manager"] != rowData.entity["note_stage_manager"])
        ) {

            isDirty = true;
            if (this.unsavedRowIndexes.indexOf(rowData.rowIndex) == -1) this.unsavedRowIndexes.push(rowData.rowIndex);

        } else if (rowData.entity["ref_vt_duty_type_actual"] && rowData.entity["ref_functional_sub_group_actual"]) {
            // alles synchron und values sind eingegeben

            isDirty = false; // ist per default, aber klarheitshalber
            if (this.unsavedRowIndexes.indexOf(rowData.rowIndex) != -1) this.unsavedRowIndexes.splice(this.unsavedRowIndexes.indexOf(rowData.rowIndex), 1);
        }

        return isDirty;
    }

    _setIsRowDirtyStyle(rowData: { entity: object, rowIndex: number }): void {
        // setzt das saave button disabled oder "enabled"

        let regEntry = this.getRegistryEntryByRowIndex(rowData.rowIndex);
        let rowWidgets: Array<MdsLax<InstanceType<typeof _StatefulBase>>> = [];
        if (regEntry) {
            rowWidgets = regEntry.widgets;
        }
        let button;

        for (let i = 0; i < rowWidgets.length; i++) {

            if (rowWidgets[i]["nodeName"] && rowWidgets[i]["nodeName"] == "BUTTON") {
                button = rowWidgets[i];
            }
        }

        // setzt das saave button disabled oder "enabled"
        if (button) {

            this.isRowDirty(rowData) && this.UiModder.domAttr.remove(button, "disabled");
            !this.isRowDirty(rowData) && this.UiModder.domAttr.set(button, "disabled", true);

            // nicht inspiziert - enable button
            if (!rowData.entity["ref_vt_duty_type_actual"] || !rowData.entity["ref_functional_sub_group_actual"]) {

                this.UiModder.domAttr.remove(button, "disabled");

            }

            // wenn saving in progeress beinhaltet rowData - button disable
            if (this.rows_savingInProcess && this.rows_savingInProcess.length) {
                for (let i = 0; i < this.rows_savingInProcess.length; i++) {
                    if (this.rows_savingInProcess[i].rowIndex == rowData.rowIndex) {
                        this.UiModder.domAttr.set(button, "disabled", true);
                        return;
                    }
                }
            }
        }


    }

    setTaskProgressStyles(): void {

        this.staticTable._removeCustomRowClasses();

        if (this.notInspectedOnly == false) {

            this.staticTable.setConditionalStyleClass("ref_vt_duty_type_actual", null, "inProgressColoration");
            this.staticTable.setConditionalStyleClass("ref_functional_sub_group_actual", "*", "allDoneColoration"); // das wildcard "*" (stern) == !null

        }
    }

    loadData(bookingID: string): void {
        
        this.bookingId = bookingID;
        this.StandbyStart(this.domNode);

        let data: { bookingID: string } = { bookingID: bookingID };

        //console.log("AttendanceListEditor loadData response: ", data )

        if (this._request != null) {
            this._request.cancel();
        }

        this._request = this.RequestManager.post(
            window.appRoot + this.loadDataControllerurl,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, "_onLoadData_Response"),
            lang.hitch(this, function (err) { // errorCallback
                this.StandbyStop();
                if (err && err["Message"] ) {
                    alert("ERROR beim Laden von Daten: " + err["Message"]);
                    console.log(err);
                } 
            })
        );

    }

    _onLoadData_Response(response): void {
        this.StandbyStop();

        if (response.duty_types && response.duty_types.length) {
            this.duty_types = response.duty_types;

            this.BE_dutyTypeActual.clear();

            for (let duty_type of this.duty_types) {
                this.BE_dutyTypeActual.addOption(duty_type.ID, duty_type.description, true);
            }

            this.BE_dutyTypeActual.setBlankOption("x", "---", true);

            this.BE_dutyTypeActual.constructOptions();

        }

        if (response.functional_sub_groups && response.functional_sub_groups.length) {
            this.functional_sub_groups = response.functional_sub_groups;
        }

        if (response && response.items && response.items.length) {

            this.data = response;

            this.all_table_entites = [];
            this.not_inspected_entities = [];

            for (let item of response.items) {
                this.all_table_entites.push(item["Entity"]);

                if (
                    !item["Entity"]["ref_vt_duty_type_actual"] ||
                    !item["Entity"]["ref_vt_duty_type_actual"].ID
                ) {
                    this._addEntityToRegistry(item["Entity"], this.not_inspected_entities);
                }
            }

            this.createTable();

            if (this.notInspectedOnly === true) {
                this.staticTable.setData(this.not_inspected_entities);
            } else {
                this.staticTable.setData(this.all_table_entites);
            }
            this.setTaskProgressStyles();


            for (let rowDataRegistryObj of this.widgetRegistry) {
                this._setIsRowDirtyStyle({ entity: rowDataRegistryObj.entity, rowIndex: rowDataRegistryObj.tableRow.lineIndex });
            }
        } else {
            this._showErrorMessage(this.domNode, this.translations["AttendanceListEditor__selectBox_placeholder_nothingToChooseFrom"], true);
        }
    }

    _showErrorMessage(container: HTMLElement, message: string, bShow: boolean): void {

        if (bShow == true) {
            container.innerHTML = null;
            this.UiModder.domClass.add(container, ["w3-pale-red", "w3-text-red", "w3-large", "w3-center"]);
            this.UiModder.domAttr.set(container, "innerHTML", message);
            this.UiModder.domConstruct.create("i", { "class": "fa fa-exclamation-triangle", "innerHTML": "&nbsp;" }, container, "first");
        } else {
            this.UiModder.domClass.remove(container, ["w3-pale-red", "w3-text-red", "w3-large", "w3-center"]);
            this.UiModder.domAttr.set(container, "innerHTML", null);
        }

    }

    createTable(): void {

        let layout: StaticTable.Layout;

        if (this.staticTable != null) {
            this.staticTable.destroy();
            this.tableContainer.innerHTML = null;
        }

        this.staticTable = new StaticTable();
        
        
        this.staticTable["duty_types"] = this.duty_types;
        this.staticTable["functional_sub_groups"] = this.functional_sub_groups;

        this.staticTable.setHeaderColor("#858585","#ffffff");
        this.staticTable.setFormatter(this.table_formatterFunction);

        this.staticTable.setCyAttribute("AttendanceListEditor");

        if (this.isBatchEditingActive == false) {
            layout = this.tableLayout;
            this.UiModder.domClass.add(this.batchEitingControls_container, "w3-hide");
        } else {
            layout = this.batchEditTableLayout;
            this.UiModder.domClass.remove(this.batchEitingControls_container, "w3-hide");
        }

        console.log("layout", layout)

        this.staticTable.setTableLayout(layout);


        this.UiModder.domConstruct.place(this.staticTable.domNode, this.tableContainer);
        if (this.data && this.all_table_entites) {
            if (this.notInspectedOnly === true) {
                console.log("p1", this.not_inspected_entities)
                this.staticTable.setData(this.not_inspected_entities);
            } else {
                console.log("p2", this.all_table_entites)
                this.staticTable.setData(this.all_table_entites);
            }
        } 
        //this.staticTable.setColumnWidth(3, 50); //LH WHY??? 

        this.setTaskProgressStyles(); /// editieren
    }

    tableRowButton_click_saveData(rowData: { entity: { ID: string }, rowIndex: number }): void {

        let rowIndex = rowData["rowIndex"];
        let regEntry = this.getRegistryEntryByRowIndex(rowData.rowIndex);
        let rowWidgets: Array<MdsLax<InstanceType<typeof _StatefulBase>>> = [];
        if (regEntry) {
            rowWidgets = regEntry.widgets;
        }
        let rowWidetValues: object = {}; //tmp

        for (let i = 0; i < rowWidgets.length; i++) {

            if (rowWidgets[i]["name"] && rowWidgets[i]["name"] == "note") {
                rowWidetValues["note_stage_manager"] = rowWidgets[i]["value"];
            } else if (rowWidgets[i]["name"] && rowWidgets[i]["name"] == "ref_vt_duty_type_actual") {
                rowWidetValues["ref_vt_duty_type_actual"] = rowWidgets[i].getValue();
            } else if (rowWidgets[i]["name"] && rowWidgets[i]["name"] == "ref_functional_sub_group_actual") {
                rowWidetValues["ref_functional_sub_group_actual"] = rowWidgets[i].getValue();
            }
        }

        let data = { entity: rowData.entity, rowIndex: rowData.rowIndex };

        // wenn die entity noch nicht inspiziert war und mindestens ein der actual_ Werte nicht vorhanden ist ODER wenn row dirty ist
        if (!data.entity["ref_vt_duty_type_actual"] || !data.entity["ref_functional_sub_group_actual"] || this.isRowDirty(rowData)) {

            // entweder eine Value war ausgewählt oder wir schleifen die geplante Entity ind die tatsächliche durch
            data.entity["ref_vt_duty_type_actual"] = rowWidetValues["ref_vt_duty_type_actual"] != "x" ? rowWidetValues["ref_vt_duty_type_actual"] : data.entity["ref_vt_duty_type"].ID;
            data.entity["ref_functional_sub_group_actual"] = rowWidetValues["ref_functional_sub_group_actual"] != "x" ? rowWidetValues["ref_functional_sub_group_actual"] : data.entity["ref_engagement"]["ref_functional_sub_group"].ID;
            data.entity["note_inspecient"] = rowWidetValues["note_inspecient"];


            this.saveRowData(data);
            this.rows_savingInProcess.push(rowData);

        }

        this._setIsRowDirtyStyle(rowData);
    }

    saveRowData(data: { entity: {ID:string}, rowIndex: number}): void {

        this._removeEntityFromRegistry(data.entity, this.not_inspected_entities);

        //console.log("SAVE DATA: ", data)

        this.RequestManager.post(
            window.appRoot + this.saveDataControllerurl,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, "_onSaveRowData_Response", data.rowIndex),
            lang.hitch(this, "_onSaveRowData_Error", data.rowIndex)
        );

    }

    _onSaveRowData_Error(rowIndex:number , err  ): void {
        //console.log("_onSaveRowData_Error", err, " , rowIndex: ", rowIndex);

        if (err && err["Message"] && err["Message"].length != 17 && err["Message"].indexOf(":") != 8) { // wenn das keine ID ist (das ist nähmlich success)
            this.rows_savingInProcess = null;
            alert("ERROR beim UpdateItemChanges: " + err["Message"]);
            console.log(err);
        } else {
            this._onSaveRowData_Response(rowIndex, err["Message"]);
        }
    }

    _onSaveRowData_Response(rowIndex: number, response ): void {

        //console.log("SAVE DATA RESPONSE: ", response, " rowindex: ", rowIndex, " saving in progress: ", this.rows_savingInProcess);

        if (this.rows_savingInProcess && this.rows_savingInProcess.length) {
            let index: number = -1;
            for (let i = 0; i < this.rows_savingInProcess.length; i++) {
                if (this.rows_savingInProcess[i].rowIndex == rowIndex) {
                    index = i;
                }
            }
            this.rows_savingInProcess.splice(index, 1);
        }

        let spliceIndex: number = this.unsavedRowIndexes.indexOf(rowIndex);
        if (spliceIndex != -1) this.unsavedRowIndexes.splice(spliceIndex, 1);

        this.loadData(this.bookingId);
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.widgetRegistry = [];
       
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
        this.createTable();
    }
}

export default mdsWidget(AttendanceListEditor);